document.addEventListener("DOMContentLoaded", (event) => {
  const lcHome = document.querySelector('[data-lc-home]');
  if (!lcHome) return;
  gsap.registerPlugin(Draggable,MotionPathPlugin,ScrollTrigger,ScrollToPlugin,InertiaPlugin)


  let sstyle = document.querySelector(".hero-scroll").style;

  function hideScroll() {
    if(window.pageYOffset > window.innerHeight * 0.5) {
      //sstyle.display = "none";
      document.querySelector(".hero-scroll").classList.remove("visible");
      window.removeEventListener('scroll', hideScroll);
    }
  }

  setTimeout(() => {
    if(window.pageYOffset < window.innerHeight * 0.5) {
      document.querySelector(".hero-scroll").classList.add("visible");
      window.addEventListener('scroll', hideScroll);
    }
      //window.addEventListener('scroll', hideScroll);
  }, 1000);

  /*new ScrollyVideo({
    src: "assets/Hero 1.mp4",
    scrollyVideoContainer: "scrolly-hero",
    trackScroll: true,
  });*/

  let scrolltriggerinitiated = false;
  let scrollervideo1;
  window.scrollvideo1 = new ScrollyVideo({
    src: lcHome.dataset.companyVideo,
    scrollyVideoContainer: "scrolly-video",
    trackScroll: true,
  });

  
  var companyCursor = document.querySelector(".company-view");
  var scrollyValsesiaEl = document.querySelector("#scrolly-valsesia");
  var scrollyVideoEl = document.querySelector("#scrolly-video");
  var valsesiaCursor = document.querySelector(".valsesia-view");

  function renderCompanyView() {
    companyCursor.style.left = companyCursor.ox + "px";
    companyCursor.style.top = (companyCursor.oy - companyCursor.sy) + "px";

    valsesiaCursor.style.left = valsesiaCursor.ox + "px";
    valsesiaCursor.style.top = (valsesiaCursor.oy - valsesiaCursor.sy) + "px";
  }
  
  
  window.addEventListener('pointermove', function(e) {
    companyCursor.ox = e.clientX;
    companyCursor.oy = e.clientY;

    valsesiaCursor.ox = e.clientX;
    valsesiaCursor.oy = e.clientY;
    renderCompanyView();
  });
  window.addEventListener('scroll', function() {
    var bcr = scrollyVideoEl.getBoundingClientRect();
    companyCursor.sy = bcr.top;

    var bcr2 = scrollyValsesiaEl.getBoundingClientRect();
    var bcr3 = document.querySelector('.valsesia-video-container').getBoundingClientRect();
    valsesiaCursor.sy = bcr3.top >= 0 ? bcr3.top : Math.min(bcr2.top, 0);
    renderCompanyView();
  });

  gsap.from("#card1", {
    scrollTrigger: {
      trigger:'.company-video-container',
      start: "top -10%",
      toggleActions: "play none none reverse",
    },
    opacity: 0,
    duration: 0.7,
    ease: "bounce.in",
    scale: 0.99,
    filter: "blur(1px)",
  });

  gsap.from("#card2", {
    scrollTrigger: {
      trigger:'.company-video-container',
      start: "top -100%",
      toggleActions: "play none none reverse",
    },
    opacity: 0,
    duration: 0.7,
    ease: "bounce.in",
    scale: 0.99,
    filter: "blur(1px)",
  });


  
  /*scrollyValsesiaEl.addEventListener('pointermove', function(e) {
    valsesiaCursor.style.left = e.offsetX + "px";
    valsesiaCursor.style.top = e.offsetY + "px";
  });*/

  const valsesiaVideo = new ScrollyVideo({
    src: lcHome.dataset.valsesiaVideo,
    scrollyVideoContainer: "scrolly-valsesia",
    trackScroll: false,
    useWebCodecs: false,
  });

  const valsesiaCards = document.querySelectorAll("#card3, #card4, #card5");

  function hideValsesiaCards() {
    valsesiaCards.forEach((card) => card.classList.remove("visible", "out"));
  }

  valsesiaVideo.video.addEventListener("ended", () => {
    valsesiaCards.forEach((card) => card.classList.add("visible"));
  });


  /*gsap.from("#card3", {
    scrollTrigger: {
      trigger:'.valsesia-video-container',
      start: "top -20%",
      toggleActions: "play none none reverse",
    },
    opacity: 0,
    duration: 0.5,
    scale: 2,
    filter: "blur(20px)",
  });
  gsap.to("#card3", {
    scrollTrigger: {
      trigger:'.valsesia-video-container',
      start: "top -70%",
      toggleActions: "play none none reverse",
    },
    opacity: 0,
    duration: 0.5,
    scale: 2,
    filter: "blur(20px)",
  });*/

  gsap.from("#scrolly-valsesia", {
    scrollTrigger: {
      trigger:'.valsesia-video-container',
      start: "top 50%",
      end: "top top",
      scrub: 0.4,
    },
    transform: "scale(0)",
  });

  ScrollTrigger.create({
    trigger:'.valsesia-video-container',
    start: "top top",
    end: "bottom bottom",
    onEnter: () => {
      scrollyValsesiaEl.classList.add("fullsize");
      hideValsesiaCards();
      valsesiaVideo.video.currentTime = 0;
      valsesiaVideo.video.play().catch(() => {
        // Il browser può bloccare l'autoplay se le sue preferenze lo impediscono.
      });
    },
    onLeaveBack: () => {
      scrollyValsesiaEl.classList.remove("fullsize");
      valsesiaVideo.video.pause();
      valsesiaVideo.video.currentTime = 0;
      hideValsesiaCards();
    }
  });


  /*const options = {
    root: document.querySelector("#scrollArea"),
    rootMargin: "0px",
    scrollMargin: "0px",
    threshold: 1.0,
  };
  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      console.log(entry);
    });
  };
  const observer = new IntersectionObserver(callback, options);
  observer.observe(document.querySelector("#card3trigger"));
  console.log(getAbsolutePosition(document.querySelector("#card3trigger")));*/

  /* OLD CAROUSEL
  const carousel = document.getElementById('iconic-carousel');
  const items = document.querySelectorAll('.item');
  let angle = 0;
  let isDragging = false;
  let startX;

  var cw = carousel.getBoundingClientRect().width;
  var wray = cw * 325 / 650;
  var hray = cw * 150 / 650;
  var scalefactor = cw * 400 / 650;
  var tx = cw / 2;
  var ty = (carousel.getBoundingClientRect().height - carousel.getBoundingClientRect().width * (260/645) ) / 2;
  //updatePositions(0)
  console.log(cw, document.querySelector("#iconic-carousel .item").getBoundingClientRect().width);

  window.updateCarouselSize = function() {
    cw = carousel.getBoundingClientRect().width;
    wray = cw * 325 / 650;
    hray = cw * 150 / 650;
    scalefactor = cw * 400 / 650;
    tx = cw / 2;
    ty = (carousel.getBoundingClientRect().height - carousel.getBoundingClientRect().width * (260/645) ) / 2;
    console.log(cw, document.querySelector("#iconic-carousel .item").getBoundingClientRect().width);
    updatePositions( gsap.getProperty(proxy, "x") );
    draggable.update();
  }

  window.addEventListener('load', () => {
    console.log("loaded")
    window.updateCarouselSize();
  });

  window.addEventListener('resize', () => {
    window.updateCarouselSize();
  });

  function updatePositions(x) {
    if(typeof x !== 'number') x = this.x;
    let s = wrapProgress( (-x || 0)  / 3000);
    angle = s * Math.PI * 2; // Converti in angolo
    items.forEach((item, i) => {
      // Calcolo posizione ellittica
      const theta = (angle + ((i+1) * Math.PI / 2));
      const x = Math.cos(theta) * wray; //325; // Raggio orizzontale
      const y = Math.sin(theta) * hray; //150; // Raggio verticale
      
      // Prospettiva: scala basata sulla posizione Y (più è basso, più è vicino)
      const scale = 0.8 + (y + 100) / scalefactor; //400; 
      const zIndex = Math.round(scale * 10);
      
      item.style.transform = `translate(calc(${x + tx}px - 50%), ${y + ty}px) scale(${scale})`;
      item.style.zIndex = zIndex;
      //item.style.opacity = scale;
    });
  }

  var picker = document.querySelector(".carousel-wrapper");
  var cells = document.querySelectorAll(".carousel-wrapper .item");
  var proxy = document.createElement("div");
  var wrapProgress = gsap.utils.wrap(0, 1);

  //let iconsnaps = Array(cells.length ).keys().toArray().map(i => (3000/cells.length)*(i));
  //console.log(Array(cells.length).keys().toArray(), iconsnaps);

  window.draggable = new Draggable(proxy, {
    // allowContextMenu: true,
    type: "x",
    trigger: picker,
    inertia: true,
    onDrag: updatePositions,
    onThrowUpdate: updatePositions,
    snap: {
      x: function(v) {
        return Math.round(v / (3000/cells.length)) * (3000/cells.length);
      }
    },
    onThrowComplete: function () {
      console.log("onThrowComplete", this.x);
      //TODO: animation that inject selected card title
    }
  });
  updatePositions();

  window.updrag = function(ind) {
    let from = draggable.x;
    let stepsize = 3000/cells.length;
    let currInd = Math.round(from / stepsize);
    currInd = (currInd % cells.length + cells.length) % cells.length; // wrap around
    let to = ind * stepsize;
    from  = currInd * stepsize;

    if( Math.abs(to - from) > 1500) {
      if(to > from) {
        from += 3000;
      }
      else {
        to += 3000;
      }
    }

    gsap.fromTo(proxy, {x: from}, {
      x: to,
      duration: 1,
      onUpdate: function() {
          updatePositions(gsap.getProperty(this.targets()[0], "x"));
          draggable.update();
      }
    })
  }

  document.querySelector('.ellipse-container').addEventListener("click", (e) => {
    console.log(e.target);
    if(e.target.classList.contains("item")) {
      let index = Array.from(cells).indexOf(e.target);
      updrag(index);
    }
  });
  */


  /* BIG BANNER PARALLAX */

  gsap.from(".big-banner img", {
    scrollTrigger: {
      trigger:'.big-banner',
      start: "top bottom",
      end: "bottom top",
      scrub: 0.2,
    },
    y: -300,
  });

  /* STORY */

  /*function updateStory() {
    let s = this.x;
    console.log(s);
    document.querySelector(".story-scroll").style.transform = `translateX(${-s}px)`;
  }*/

  /*var draggable = new Draggable(proxy, {
    // allowContextMenu: true,
    type: "x",
    trigger: document.querySelector('.story-container'),
    inertia: true,
    onDrag: updateStory,
    onThrowUpdate: updateStory,
  });*/
  //let minstory = document.querySelector(".story-scroll").getBoundingClientRect().width - document.querySelector(".story-view").getBoundingClientRect().width;


  var _prevstoryX = 0;
  var _storyImgOffsetX = 0;
  var _storyImgOffsetY = 0;
  function updateStoryPointer(x) {
    if(typeof x !== 'number') x = this.x;
    
    let s = -x;
    document.querySelector('.story-pointer').style.width = `${(-s / minstory) * 100}%`;
    let minDist = 1000;
    for(let i = 0; i < snaps.length; i++) {
      let dist = Math.abs(x - snaps[i]);
      if( dist < minDist ) {
        minDist = dist;
      }
      if( x <= snaps[i] )
        document.querySelectorAll(".story-item")[i].classList.add("active");
      else
        document.querySelectorAll(".story-item")[i].classList.remove("active");
    }
    if(minDist < 2)
      document.querySelector('.story-pointer').classList.add("wider");
    else
      document.querySelector('.story-pointer').classList.remove("wider");
  }

  var minstory = 0;
  let nItems = document.querySelectorAll(".story-item").length;
  for(let item of document.querySelectorAll(".story-item")) {
    minstory += item.getBoundingClientRect().width;
  }
  //minstory -= document.querySelector(".story-view").getBoundingClientRect().width;
  minstory = -minstory;
  
  window.addEventListener('resize', () => {
    minstory = 0;
    for(let item of document.querySelectorAll(".story-item")) {
      minstory += item.getBoundingClientRect().width;
    }
    //minstory -= document.querySelector(".story-view").getBoundingClientRect().width;
    minstory = -minstory;
    snaps = Array(nItems).keys().toArray().map(i => minstory*i/(nItems - 1));

    console.log( dragstory[0])
    
    
    let x = gsap.getProperty('.story-item img.active', 'x');
    dragstory[0].vars.snap = snaps;
    dragstory[0].vars.bounds.minX = minstory;
    dragstory[0].update(true/*document.querySelectorAll(".story-item.active").length - 1, 0*/);
    dragstory[0].x = snaps[document.querySelectorAll(".story-item.active").length - 1];
    
    updateStoryPointer( snaps[document.querySelectorAll(".story-item.active").length - 1] );

    //updateStory();

    updateStory( document.querySelectorAll(".story-item.active").length - 1, 0 );
  });

  var snaps = Array(nItems).keys().toArray().map(i => minstory*i/(nItems - 1));
  console.log('snaps', snaps);
  window.dragstory = Draggable.create(".story-scroll", {
    type: "x",
    snap: snaps,
    trigger: document.querySelector('.story-container'),
    bounds: {minX: minstory, maxX: 0},
    inertia: true,
    dragResistance: document.querySelector('.story-container').offsetWidth > 500 ? 0.75 : 0.45,
    throwResistance: 500,
    maxDuration: 1,
    onDrag: updateStoryPointer,
    onThrowUpdate: updateStoryPointer,
    onThrowComplete: function () {
      let i = 1;
      while(this.x < snaps[i] +1 && i < snaps.length) {
        i++;
      }
      console.log(this.x, snaps);
      //document.querySelector('.story-current.active')?.classList.remove("active");
      //document.querySelectorAll('.story-current')[i-1].classList.add("active");
      updateBigStory(i-1);
    }
  });

  updateBigStory(0);

  window.updateStory = function(ind, duration) {
    ind = Math.max(0, Math.min(document.querySelectorAll('.story-item').length - 1, ind));
    let d = duration || 0.7;
    let from = dragstory[0].x;
    let to = snaps[ind];

    updateBigStory(ind);
    gsap.fromTo(".story-scroll", {x: from}, {
      x: to,
      duration: d,
      onUpdate: function(upd) {
        //console.log('update', upd, this);
          updateStoryPointer(gsap.getProperty(this.targets()[0], "x"));
          let x = gsap.getProperty('.story-item img.active', 'x');
          dragstory[0].update();
      },
      onComplete: function() {
        //document.querySelector('.story-current.active')?.classList.remove("active");
        //document.querySelectorAll('.story-current')[ind].classList.add("active");
        updateBigStory(ind);
      }
    })
  }

  function updateBigStory(ind) {
    //let active = document.querySelector('.story-item img.active');
    //let bigActive = document.querySelector('.story-current.active');
    let currind = Array.from(document.querySelectorAll(".story-item")).indexOf(document.querySelectorAll('.story-item.current'));
    console.log('indexes', ind, currind);
    if(ind == currind) return;
   
    document.querySelector('.story-item.current')?.classList.remove("current");
    document.querySelectorAll('.story-item')[ind].classList.add("current");
    
    if(ind <= 0) 
      document.querySelector('.story-arrow.prev').classList.add('inactive');
    else
      document.querySelector('.story-arrow.prev').classList.remove('inactive');

    if(ind >= document.querySelectorAll(".story-item").length - 1) 
      document.querySelector('.story-arrow.next').classList.add('inactive');
    else
      document.querySelector('.story-arrow.next').classList.remove('inactive');

  }

  document.querySelector('.story-arrow.prev').addEventListener('click', function(e) {
    let currind = Array.from(document.querySelectorAll(".story-item")).indexOf(document.querySelector('.story-item.current'));
    updateStory(currind - 1);
  });
  document.querySelector('.story-arrow.next').addEventListener('click', function(e) {
    let currind = Array.from(document.querySelectorAll(".story-item")).indexOf(document.querySelector('.story-item.current'));
    console.log('going to ', currind+1)
    updateStory(currind + 1);
  });

  document.querySelector('.story-scroll').addEventListener("click", (e) => {
    console.log(e.target);
    if(e.target.classList.contains("story-date") || e.target.tagName == 'IMG') {
      let index = Array.from(document.querySelectorAll(".story-item")).indexOf(e.target.parentElement);
      updateStory(index);
    }
  });
});

window.addEventListener('load', function() {
  ScrollTrigger.refresh();
})


function getAbsolutePosition(element) {
    const rect = element.getBoundingClientRect();
    
    return {
        top: rect.top + window.scrollY,    // Add vertical scroll
        left: rect.left + window.scrollX,  // Add horizontal scroll
        bottom: rect.bottom + window.scrollY,
        right: rect.right + window.scrollX
    };
}
